<template>
    <AdUnitsPendingApprovalModal @ok="closeModal"></AdUnitsPendingApprovalModal>
</template>

<script>

import eventBus from '../mixins/eventBus';
import AdUnitsPendingApprovalModal from 'monetize/adUnitSettings/PendingApprovalModal.vue';


export default {
    name: 'AdUnitsPendingApprovalModalEx',
    components: { AdUnitsPendingApprovalModal },
    mixins: [
        eventBus('ad-units-pending-approval-modal-ex')
    ],
    methods: {
        closeModal(data) {
            this.$emit('closeModal', data);
        }
    }
};
</script>

<style scoped>

</style>
